export default __webpack_public_path__ + "static/media/JS1.130c0ecd.png";